import styled from 'styled-components/macro';
import { colorCoreWhite1000, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const LeadFormContainer = styled(FlexWrapper) `
  background-color: ${colorCoreWhite1000};
  border-top: 6px solid ${colorCoreBlack900Base};
`;
export const LeadFormStyled = styled.div `
  ${ADAPTIVE.maxWidth.mobile} {
    margin-left: -16px;
    margin-right: -16px;
  }
`;
export const LeadFormErrorButtonWrapperStyled = styled.div `
  margin-top: 24px;
  width: ${(props) => (props.isFullWidth ? '100%' : 'fit-content')};
`;
